@if (
  VendorId &&
  country &&
  VendorMailingAddress &&
  (!InsuranceAgentId || InsuranceAgents.length > 0)
) {
  <div class="modal-header">
    <h3 class="mb-0">
      {{ InsuranceAgentId ? 'Edit insurance agent' : 'Add insurance agent' }}
    </h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <app-insurance-agent-edit
      [VendorId]="VendorId"
      [country]="country"
      [InsuranceAgentFormGroup]="InsuranceAgentFormGroup"
      [CompanyVendorFormGroup]="CompanyVendorFormGroup"
      [VendorMailingAddress]="VendorMailingAddress"
      [hideSaveButton]="true"
      [currentInsuranceAgentPolicies]="currentInsuranceAgentPolicies"
      [InsuranceAgents]="InsuranceAgents"
    ></app-insurance-agent-edit>
  </div>

  <div class="modal-footer">
    <div class="action-row w-100 align-items-center">
      <button type="button" class="btn btn-ghost" (click)="resetForm()">
        Reset form
      </button>
      <span class="ms-auto"></span>
      <button type="button" class="btn btn-ghost" (click)="close()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="save()">
        Save
      </button>
    </div>
  </div>
}
